/**
 * Rule keys for the Formsy migration bridge (`validations` / `validationErrors` / `forceError`).
 * In Zod schemas, express rules with zod APIs; use these constants only while mirroring
 * legacy Formsy props.
 */
export const FORM_VALIDATION_RULE = {
  IS_EMAIL: 'isEmail',
  IS_SPECIAL_WORDS: 'isSpecialWords',
  MIN_LENGTH: 'minLength',
  MAX_LENGTH: 'maxLength',
  MATCH_REGEXP: 'matchRegexp',
  REQUIRED: 'required',
} as const

export type FormValidationRuleKey = typeof FORM_VALIDATION_RULE[keyof typeof FORM_VALIDATION_RULE]
